module.exports = __webpack_public_path__ + "media/african-grey-parrot.3d24654b.mp3";